"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormContext = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _excluded = ["children", "validationSchema", "updateOnBlur"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FormContext = /*#__PURE__*/(0, _react.createContext)(null);
// This provider is needed because Formik doesn't expose the validation schema in any hook.
// This is a known feature request and will be fixed in v3: https://github.com/jaredpalmer/formik/pull/3231
var HBFormProvider = function HBFormProvider(_ref) {
  var children = _ref.children,
    validationSchema = _ref.validationSchema,
    updateOnBlur = _ref.updateOnBlur,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasSubmittedOnce = _useState2[0],
    setHasSubmittedOnce = _useState2[1];

  // validationSchema.describe() is a very heavy call so this is all to reduce the calls to it to the absolute minimum
  var schemaRef = (0, _react.useRef)(null);
  var schemaDescribedRef = (0, _react.useRef)(null);
  if (validationSchema && schemaRef.current !== validationSchema) {
    schemaRef.current = validationSchema;
    schemaDescribedRef.current = validationSchema.describe();
  }
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, (0, _extends2["default"])({}, props, {
    validationSchema: validationSchema,
    validateOnBlur: hasSubmittedOnce,
    validateOnChange: hasSubmittedOnce
  }), function (formProps) {
    formProps.validationSchema = schemaDescribedRef.current;
    formProps.updateOnBlur = updateOnBlur;
    if (formProps.submitCount > 0) {
      setHasSubmittedOnce(true);
    }
    return /*#__PURE__*/_react["default"].createElement(FormContext.Provider, (0, _extends2["default"])({
      value: formProps
    }, props), typeof children === 'function' ? children(formProps) : children);
  });
};
var _default = exports["default"] = HBFormProvider;
var useFormContext = exports.useFormContext = function useFormContext() {
  return (0, _react.useContext)(FormContext);
};
//# sourceMappingURL=HBFormProvider.js.map